/* eslint-disable no-plusplus */
import { CashFlowRow } from "../../../../data/_config/shape"

export function monthDiff(d1, d2) {
	let months
	months = (d2.getFullYear() - d1.getFullYear()) * 12
	months -= d1.getMonth()
	months += d2.getMonth()
	return months <= 0 ? 1 : months + 1
}

export function getMounthTitle(d) {
	const monthNames = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"Maj",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	]

	return monthNames[d.getMonth()]
}

export function getMounthDay(d1): string {
	return d1.getMonth() + 1 + "." + d1.getFullYear()
}

export function createAllRows({
	type,
	timeframe,
	startDate,
	endDate,
}: any): CashFlowRow[] {
	let diff = 0

	if (startDate && endDate) diff = monthDiff(startDate, endDate)
	if (diff === 0) {
		return []
	}
	const rows: CashFlowRow[] = []
	let counter = 1

	for (let i = 1; i <= 3; i++) {
		const currentMounth: Date = new Date(startDate.getTime())
		const outRow: CashFlowRow = {
			id: counter++,
			title: "PLAĆANJA",
			subtitle: "Plaćanje " + i,
			type: "out",
			amount: null,
			mounth: {},
		}

		let outRow1: CashFlowRow = {}

		if (type !== "planirani") {
			outRow.subtitleItem = "realizacija"
			outRow.includedInSum = false

			outRow1 = {
				id: counter++,
				title: "PLAĆANJA",
				subtitle: "Plaćanje " + i,
				subtitleItem: "placanje",
				includedInSum: true,
				type: "out",
				amount: null,
				mounth: {},
			}
		}

		const inRow = {
			id: counter++,
			title: "PRILIVI",
			subtitle: "Priliv " + i,
			type: "in",
			amount: null,
			mounth: {},
		}

		for (let j = 0; j < diff; j++) {
			outRow.mounth[getMounthDay(currentMounth)] = null

			if (type !== "planirani") {
				outRow1.mounth[getMounthDay(currentMounth)] = null
			}

			inRow.mounth[getMounthDay(currentMounth)] = null

			currentMounth.setMonth(currentMounth.getMonth() + 1)
		}

		rows.push(outRow)

		if (type !== "planirani") {
			rows.push(outRow1)
		}

		rows.push(inRow)
	}

	return rows
}
